<template>
  <div>
    <header class="sticky">
      <div class="d-header">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12 head-st">
              <div class="logo">
                <router-link to="/projects">
                  <img class="img-responsive" src="@/assets/images/Logo.png" alt="logo" />
                </router-link>
              </div>
              <div class="title-head pr-2">{{$t('customer_administration')}}</div>
              <div class="user-icon">
                <span style="width: 40px; margin-right: 40px;">
                  <a href="https://projectdocu.com/hilfe-und-tutorials-baustellendokumentation/" target="_blank" style="color:#666666; position: absolute;"  alt="Hilfe & Anleitungen" title="Hilfe & Anleitungen">
                    <i class="fa-regular fa-circle-question" style="font-size: 35px;margin-top: 5px;"></i>
                  </a>
                </span>
                <!--                <span>-->
                <!--                  <img class src="@/assets/images/user.png" alt="user" width="40" />-->
                <!--                </span>-->
                <span class="u-txt">{{ nameShowInheader }}</span>
                <span class="u-dp">
                  <div class="dropdown show">
                    <img class="img-responsive dropdown-toggle arrow-img" src="@/assets/images/dropdown.png" alt="user" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"/>
                    <div class="dropdown-menu dropdown-menu-right dp-box" aria-labelledby="dropdownMenuLink">
                      <a class="dropdown-item" data-toggle="modal" data-target="#exampleModalCenter"  href="#"  @click="emptyModal">
                        <img class="img-responsive" src="@/assets/images/Shape.png" alt="shapw" />
                        <span>{{$t('profile_edit')}}</span>
                      </a>
                      <a class="dropdown-item" data-toggle="modal" data-target="#exampleModalCenter2" href="#">
                        <img class="img-responsive" src="@/assets/images/Shape1.png" alt="shapw" />
                        <span>{{$t('language')}}</span>
                      </a>

                      <template v-if="isCustomerAdmin">
                          <div style="background-color: white !important;"
                               class="dropdown-item"
                               @mouseover="showcustomerdropdown = true"
                               @mouseleave="showcustomerdropdown = false">
                            <img class="img-responsive" src="@/assets/images/Shape2.png" alt="shapw" />
                            <span>Kundenverwaltung</span>
                            <div class="" v-if="showcustomerdropdown">
                              <template  v-for="(item,i) in customers">
                                <a class="dropdown-item" v-bind:href="'/customer/' + item.customer_id" style="margin-left:20px;">
                                  <span>{{ item.customer.company_name }}</span>
                                </a>
                              </template>
                            </div>
                          </div>
                      </template>



                      <!--                      <a class="dropdown-item" href="#">-->
                      <!--                        <img class="img-responsive" src="@/assets/images/Shape2.png" alt="shapw" />-->
                      <!--                        <span>{{ $t('customer_administration') }}-->
                      <!--                        </span>-->
                      <!--                      </a>-->
                      <a class="dropdown-item" href="#" @click="logout()">
                        <img class="img-responsive" src="@/assets/images/Shape3.png" alt="shapw" />
                        <span>{{$t('logout')}}</span>
                      </a>
                    </div>
                  </div>
                </span>
              </div>
            </div>
          </div>
            <div data-v-9037ce1a="" class="row navbar-dark">
              <div data-v-9037ce1a="" class="col-xl-12 col-lg-12 col-md-12">
                <nav data-v-9037ce1a="" class="navbar navbar-expand-lg p-0">
                  <button data-v-9037ce1a="" type="button" data-toggle="collapse" data-target="#navbarText" aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation" class="navbar-toggler">
                    <span data-v-9037ce1a="" class="navbar-toggler-icon"></span>
                  </button>
                  <div data-v-9037ce1a="" id="navbarText" class="collapse navbar-collapse">
                    <ul data-v-9037ce1a="" class="navbar-nav mx-auto">

                      <li class="nav-item" :class="{ active: $route.area === 'dashboard' }">
                        <router-link  class="nav-link" :to="{ name: 'Customerarea', params: { customerid: this.$route.params.customerid, area: 'dashboard' }}">{{$t('Dashboard')}}</router-link>
                      </li>
                      <li class="nav-item" :class="{ active: $route.area === 'users' }">
                        <router-link  class="nav-link" :to="{ name: 'Customerarea', params: { customerid: this.$route.params.customerid, area: 'users' }}">{{$t('Users')}}</router-link>
                      </li>
                      <li class="nav-item" :class="{ active: $route.area === 'projects' }">
                        <router-link  class="nav-link" :to="{ name: 'Customerarea', params: { customerid: this.$route.params.customerid, area: 'projects' }}">{{$t('Projects')}}</router-link>
                      </li>
                      <li class="nav-item" :class="{ active: $route.area === 'licences' }">
                        <router-link  class="nav-link" :to="{ name: 'Customerarea', params: { customerid: this.$route.params.customerid, area: 'licences' }}">{{$t('Licences')}}</router-link>
                      </li>

                    </ul>
                  </div>
                </nav>
            </div>
          </div>
        </div>
      </div>
      <!--Navbar-->
      <div class="m-header">
        <nav class="navbar navbar-light light-blue lighten-4">
          <!-- Navbar brand -->
          <a class="navbar-brand logo" href="#">
            <img class="img-responsive" src="@/assets/images/Logo.png" alt="logo" />
          </a>

          <!-- Collapse button -->
          <button
            class="navbar-toggler toggler-example"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent1"
            aria-controls="navbarSupportedContent1"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="dark-blue-text">
              <i class="fa fa-bars fa-1x"></i>
            </span>
          </button>
        </nav>
          <!-- Collapsible content -->

      </div>
      <div class="spinner-cover" style="display: none;">
        <div class="spinner"></div>
      </div>
      <!--/.Navbar-->

    </header>

  </div>
</template>
<script>
import axios from 'axios'
import {
  required,
  email,
  minLength,
  numeric,
  sameAs
} from 'vuelidate/lib/validators'
import user from '../appSetting/components/Users'
export default {
  name: 'CustomerHeader',
  data () {
    return {
      nameShowInheader: '',
      isCustomerAdmin: false,
      customers: [],
      showcustomerdropdown: false,
      customer_id: 0
    }
  },
  created () {
    console.log('Customer Header created')
    this.customer_id = this.$route.params.customerid
    this.getrecord(); // Benjamin: Auskommentiert - Adaption?
    this.getiscustomeradmin();
  },
  validations () {
  },
  beforeCreate () {
    // localStorage.apikey='5b9ccf76e45cba2867816580aa5b13b3';
    if (!localStorage.apikey) this.$router.push('/login')
  },

  methods: {
    sortByDateDesc () {
      this.$store.state.projects.activeprojects.sort((a, b) => new Date(b.startdate.replaceAll('-','/')) - new Date(a.startdate.replaceAll('-','/')))

    },
    sortByDateAsc () {
      this.$store.state.projects.activeprojects.sort((a, b) => new Date(a.startdate.replaceAll('-','/')) - new Date(b.startdate.replaceAll('-','/')))
    },
    sortByNameDesc () {
      this.$store.state.projects.activeprojects.sort((a, b) => a.name.localeCompare(b.name))
    },
    sortByNameAsc () {
      this.$store.state.projects.activeprojects.sort((a, b) => b.name.localeCompare(a.name))
    },
    changeLang () {
      this.$i18n.locale = this.lang
      localStorage.locale = this.lang
      $('#exampleModalCenter2').modal('hide')
    },
    async getiscustomeradmin() {
      let _this = this;
      await axios.post(process.env.VUE_APP_BASE_AMF_URL + `&token=` + localStorage.sessiontoken, {
        parameters: [],
        serviceName: "ProjectdocuCustomer",
        methodName: "iscustomeradmin"
      }, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(response => {
        console.log(response)
        if(response.data == false) {
          // Do Nothing because is not admin!
        } else {
          _this.isCustomerAdmin = true
          _this.customers = response.data
        }

        console.log('This', _this.isCustomerAdmin, _this.customers)


        // this.$store.commit('setAuthUser',response.data[0]);
        // this.user = response.data[0]
        // localStorage.user = this.user
        // if (this.user.firstname === "" && this.user.lastname === "" && this.user.city === "" && this.user.street === ""){
        //   $('#exampleModalCenter').modal('show');
        // }
        // this.nameShowInheader = this.user.firstname + ' ' + this.user.lastname
      }).catch(e => {
        // localStorage.clear()
        this.$router.push('/projects')
      });
    },
    async getrecord () {
      await axios.post(process.env.VUE_APP_BASE_AMF_URL + `&token=` + localStorage.sessiontoken, {
        parameters: [],
        serviceName: "ProjectdocuService",
        methodName: "getCurrentUser"
      }, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(response => {
        this.$store.commit('setAuthUser',response.data[0]);
        this.user = response.data[0]
        localStorage.user = this.user
        if (this.user.firstname === "" && this.user.lastname === "" && this.user.city === "" && this.user.street === ""){
          $('#exampleModalCenter').modal('show');
        }
        this.nameShowInheader = this.user.firstname + ' ' + this.user.lastname
      }).catch(e => {
        localStorage.clear()
        this.$router.push('/login')
      });
    },


    async logout () {
      localStorage.apikey = null
      await this.$store.dispatch('logout');
      await this.$router.push('/login')
    },
    emptyModal () {
      this.modal3 = []
      this.emodal3 = []
      this.passwordChange = false
    },
    openTab (dataName) {
      this.tabA = this.tabB = this.tabC = 0
      if (dataName == 'DataA') this.tabA = 1
      if (dataName == 'DataB') this.tabB = 1
      if (dataName == 'DataC') this.tabC = 1
      let i
      let x = document.getElementsByClassName('d1')
      for (i = 0; i < x.length; i++) {
        x[i].style.display = 'none'
      }
      document.getElementById(dataName).style.display = 'block'
    }
  },
  watch: {
    search: function (val) {
      this.$store.state.projects.search = val
    },
    modal3: function (val) {
      setTimeout(function () {
        $('.alert').alert('close')
      }, 2000)
    },
    msg: function (val) {
      setTimeout(function () {
        $('.alert').alert('close')
      }, 2000)
    },
    emodal3: function (val) {
      setTimeout(function () {
        $('.alert').alert('close')
      }, 2000)
    },
    error: function (val) {
      setTimeout(function () {
        $('.alert').alert('close')
      }, 2000)
    }
  }
}
</script>
<style scoped>
.profile-btn .btn-light:hover{
  background: #3498db;
  color: white !important;
}
.sorting-project .dropdown-toggle::after {
  font-size: 1.5rem;
  position: absolute;
  top: 3px;
  right: 1px;
  padding: 14px;
}
.dropdown-menu.order-by span.mrk{
  visibility: hidden;
}
.dropdown-menu.order-by span.visible{
  visibility: visible;
}
.dropdown-menu.sorting-projects{
  top: 10px !important;
  left: -11px !important;
}
.search-bar div.sorting-photos{
  width: 145px;
}
@media (max-width: 1100px){
  .main-content {
    padding: 0 55px 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/customers/Header.vue